
  import {defineComponent} from 'vue';

  export default defineComponent({
    name: 'oauth-bridge-view',
    mounted(): void {
      const token = this.$route.query.token;

      if (token) {
        window.opener.vm.parentView.saveToken(token);
        window.opener.vm.parentView.moveToNextPage();
      } else {
        window.opener.vm.parentView.alertLoginFailed();
      }
      window.close();
    }
  });
